export function infoSlider() {
    const $slider = $(".info-slider");
    const $prev = $(".info-holder .prev");
    const $next = $(".info-holder .next");
    $slider.slick({
        infinite: false,
        arrows: true,
        fade: true,
        dots: true,
        prevArrow: $prev,
        nextArrow: $next,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
    $slider.on("beforeChange", function (){
        let $video = $slider.find("video");
        if($video.length){
            $video.get(0).pause();
        }
    });
    $slider.on("afterChange", function (event, slick, currentSlide){
        let $video = $(slick.$slides[currentSlide]).find("video");
        if($video.length){
            $video.get(0).play();
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/infoSlider.js